<template>
	<c-dialog ref="dialog" mode="slide" width="70vw" mask-close>
		<div class="m-dialog-body">
		<!-- 归还商品明细 -->
            <c-title>归还商品明细</c-title>
		<div class="m-detail-card flex-column">
			<div class="m-toolbar flex-center-cross">
				<div class="m-scan-input-box">
					<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanHandle"></c-input>
					<i class="m-scan-icon">
						<svg viewBox="0 0 24 24" width="18" height="18">
							<rect x="2" y="6" width="20" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.6"/>
							<line x1="6" y1="10" x2="6" y2="14" stroke="currentColor" stroke-width="1.6"/>
							<line x1="10" y1="9" x2="10" y2="15" stroke="currentColor" stroke-width="1.6"/>
							<line x1="14" y1="9" x2="14" y2="15" stroke="currentColor" stroke-width="1.6"/>
							<line x1="18" y1="10" x2="18" y2="14" stroke="currentColor" stroke-width="1.6"/>
							<line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="1" stroke-dasharray="2,2"/>
						</svg>
					</i>
				</div>
				<c-button color="main" @click="scanHandle">确定</c-button>
				<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
			</div>

			<c-table ref="list" :data="productList" :paging="false" @dataChange="selectChange">
				<template #empty>
					<div class="m-empty-state">
						<div class="m-empty-icon">
							<svg viewBox="0 0 64 64" width="64" height="64">
								<rect x="8" y="18" width="48" height="28" rx="4" fill="none" stroke="currentColor" stroke-width="3"/>
								<line x1="16" y1="26" x2="16" y2="38" stroke="currentColor" stroke-width="3"/>
								<line x1="24" y1="24" x2="24" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="32" y1="24" x2="32" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="40" y1="24" x2="40" y2="40" stroke="currentColor" stroke-width="3"/>
								<line x1="48" y1="26" x2="48" y2="38" stroke="currentColor" stroke-width="3"/>
								<line x1="8" y1="32" x2="56" y2="32" stroke="currentColor" stroke-width="2" stroke-dasharray="3,3"/>
							</svg>
						</div>
						<p>请扫描产品背贴码</p>
					</div>
				</template>

				<c-table-column type="selector" width="40"></c-table-column>
				<c-table-column label="产品信息" width="300">
					<template #default="{data}">
						<c-state dict="LEVEL_TYPE" tag :value="data.level_type"></c-state>
						<span>{{data.product_info || getProductText(data)}}</span>
					</template>
				</c-table-column>
				<c-table-column label="背贴码" width="140">
					<template #default="{data}">{{data.produce_unique_code || '-'}}</template>
				</c-table-column>
				<c-table-column label="IMEI" width="150">
					<template #default="{data}">{{data.produce_imei || '-'}}</template>
				</c-table-column>
				<c-table-column label="借货人" width="120">
					<template #default="{data}">{{data.borrower_name || '-'}}</template>
				</c-table-column>
                <c-table-column label="借货时间" width="120">
					<template #default="{data}">{{data.lend_date || '-'}}</template>
				</c-table-column>
				<c-table-column label="操作" width="80" type="button">
					<template #default="{data}">
						<c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</div>
		</div>

		<!-- 底部按钮 -->
		<template #button>
			<c-button size="dialog" color="main" :disabled="!productList.length" @click="submitHandle">确认归还</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleLendReturn',

		data() {
			return {
				scanCode: '',
				productList: [],
				selectedList: []
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data) {
				this.scanCode = '';
				this.selectedList = [];
				// 接收列表页传入的预选项
				this.productList = (data && Array.isArray(data) ? data : []).map(item => Object.assign({}, item));
				this.$refs.dialog.open({title: '批量归还'});
				this.focusInput();
			},

			/*********聚焦输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********扫码处理**********/
			scanHandle() {
				var code = this.scanCode.trim();
				if (!code) {
					this.$message({message: '请输入背贴码', type: 'warn'});
					return;
				}
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({message: '该背贴码已添加', type: 'warn'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				// 通过背贴码查询未归还的借出记录
				this.request({
					url: '/sale/lend/batchReturn/scan',
					data: {
						produce_unique_code: code
					},
					loading: true,
					success: (data) => {
						if (!data) {
							this.$message({message: '未找到该背贴码的借出记录', type: 'warn'});
							this.scanCode = '';
							this.focusInput();
							return;
						}
						this.productList.push(data);
						this.scanCode = '';
						this.focusInput();
					},
					fail: (msg) => {
						this.$message({message: msg, type: 'warn'});
						this.scanCode = '';
						this.focusInput();
					}
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********选中变化**********/
			selectChange() {
				this.selectedList = this.$refs.list.getData('selected');
			},

			/*********移除单项**********/
			removeItem(data) {
				this.productList = this.productList.filter(item => item.id != data.id);
				this.focusInput();
			},

			/*********批量移除**********/
			batchRemove() {
				if (!this.selectedList.length) {
					this.$message({message: '请先勾选要移除的记录', type: 'warn'});
					return;
				}
				var ids = this.selectedList.map(item => item.id);
				this.productList = this.productList.filter(item => !ids.includes(item.id));
				this.selectedList = [];
				this.focusInput();
			},

			/*********提交归还**********/
			submitHandle() {
				if (!this.productList.length) {
					this.$message({message: '请至少添加一个商品', type: 'warn'});
					return;
				}
				this.$confirm({
					message: '确认归还所选的' + this.productList.length + '条借出记录吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/lend/batchReturn',
							data: {
								lend_product_ids: this.productList.map(item => item.id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '归还成功', type: 'success'});
								this.$refs.dialog.close();
								this.$emit('resolve');
							}
						});
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-dialog-body {
		padding: 0 20px;
		display: flex;
		flex-direction: column;
	}

	.m-detail-card {
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
	}

	.m-section-title {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		border-bottom: 1px solid #e8e8e8;

		.c-title {
			margin: 0;
		}
	}

	.m-toolbar {
		padding: 10px 16px;
		background: #fafafa;
		border-bottom: 1px solid #e8e8e8;
		gap: 10px;

		.m-scan-input-box {
			position: relative;
			width: 240px;

			/deep/ .c-input input {
				background: #fffbe6;
				padding-right: 32px;
			}

			.m-scan-icon {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				color: #999;
				cursor: pointer;
			}
		}
	}

	.m-empty-state {
		padding: 60px 0;
		text-align: center;
		color: #999;

		.m-empty-icon {
			color: #ddd;
		}

		p {
			margin-top: 10px;
			font-size: 14px;
		}
	}
</style>
